import React from "react";
import { func, number, string } from "prop-types";
import { Card, Heading } from "uikit/components";
import styles from "./NumericalIndicatorCard.module.styl";
import IconTooltip from "uikit/components/IconTooltip/IconTooltip";
import cx from "classnames";
import { percentageLevels } from "utils/indicator/indicatorSettings";

export default function NumericalIndicatorCard({
    title,
    value,
    info,
    descriptionTitle,
    onClick,
    dataTestName,
}) {
    return (
        <Card
            borderRadius={"giant"}
            padding={"none"}
            className={cx(styles.form, onClick && styles.link)}
            borderColor={percentageLevels.goodStyle.colorName}
            onClick={onClick}
            name={dataTestName}
        >
            <div className={styles.content}>
                <div>
                    <div className={styles.heading}>
                        <Heading size={"h2"}>{title}</Heading>
                        <div className={styles.icon}>
                            <IconTooltip trigger={"hover"}>
                                <div className={styles.infoPanel}>{info}</div>
                            </IconTooltip>
                        </div>
                    </div>
                    <div className={styles.indicators}>
                        <div className={styles.numerator}>{value}</div>
                    </div>
                    <Heading size={"h3"} className={styles.descriptionTitle}>
                        {descriptionTitle}
                    </Heading>
                </div>
            </div>
        </Card>
    );
}

NumericalIndicatorCard.propTypes = {
    title: string.isRequired,
    value: number.isRequired,
    info: string.isRequired,
    descriptionTitle: string.isRequired,
    dataTestName: string,
    onClick: func,
};
